<div class="form-group" [formGroup]="group">
    <label [ngClass]="{'required': isFieldRequired}">{{name}}</label>
    <input type="email"
           name="Text"
           formControlName="Text"
           class="form-control form-control-lg input-full"
           placeholder="{{ placeholder}}">
    <ips-show-errors [control]="group.get('Text')" [errorMessages]="getErrorMessages()"></ips-show-errors>
</div>
